export const SIZE_OUT_OF_BOUNDS = {
  file: "File size is above limit",
};

export const DEFAULT_FIELDS = {
  CONTENT_REVIEW: { errors: [], passed: true },
};
export const MEGA = 1000000;
export const KILO = 1000;
export const FILE_TYPES = {
  JPG: "image/jpg",
  JPEG: "image/jpeg",
  PNG: "image/png",
  PDF: "application/pdf",
  NOT_SUPPORTED: "NOT_SUPPORTED",
  ALL_IMAGES:"image/*"
};


export const IMAGE_EXTENSIONS = ["jpeg", "jpg", "png"];